"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get4 = _interopRequireDefault(require("lodash/get"));
require("../../../styles/myAccount/contactPreferences.scss");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _reduxForm = require("redux-form");
var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));
var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _ListGroup = _interopRequireDefault(require("angieslist-react-components/lib/ListGroup"));
var _ListGroupItem = _interopRequireDefault(require("angieslist-react-components/lib/ListGroupItem"));
var _ReduxForm = _interopRequireDefault(require("angieslist-react-components/lib/ReduxForm"));
var _Modal = _interopRequireDefault(require("angieslist-react-components/lib/Modal"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
var memberMgmtGatewayActions = _interopRequireWildcard(require("../../../../actions/memberMgmtGatewayActions"));
var serviceProviderGatewayActions = _interopRequireWildcard(require("../../../../actions/serviceProviderGatewayActions"));
var myAccountUIActions = _interopRequireWildcard(require("../../../../actions/myAccountUIActions"));
var _contactPreferenceCopy = _interopRequireDefault(require("../../contactPreferenceCopy"));
var _fixContactPrefLinks = require("../fixContactPrefLinks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(userId, values, handleClose, saveUserContactPreferences, saveAssociateContactPreferences, appName) {
  var preferences = (0, _map2["default"])(values, function (value, k) {
    return {
      key: k,
      enabled: value
    };
  });
  var params = {
    userId: Number(userId),
    preferences: preferences
  };
  var gateWayActions = appName === 'member-app' ? saveUserContactPreferences : saveAssociateContactPreferences;
  gateWayActions(params).then(function () {
    handleClose();
  });
};
var ContactPreferencesModal = function ContactPreferencesModal(_ref) {
  var dirty = _ref.dirty,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    editButtonStyle = _ref.editButtonStyle,
    cancelButtonStyle = _ref.cancelButtonStyle,
    handleSubmit = _ref.handleSubmit,
    userId = _ref.userId,
    email = _ref.email,
    gateWay = _ref.gateWay,
    saveUserContactPreferences = _ref.saveUserContactPreferences,
    saveAssociateContactPreferences = _ref.saveAssociateContactPreferences,
    appName = _ref.appName,
    handleClose = _ref.handleClose,
    showModal = _ref.showModal;
  var _get2 = (0, _get4["default"])(gateWay, 'getContactPreferences'),
    isContactPreferenceLoading = _get2.isLoading,
    getContactPreferencesError = _get2.error,
    contactPrefsResponse = _get2.response;
  var _get3 = (0, _get4["default"])(gateWay, 'saveContactPreferences'),
    isSaveContactPreferencesLoading = _get3.isLoading,
    saveContactPreferencesError = _get3.error;
  var errorMessage = (0, _getErrorMessage["default"])(getContactPreferencesError || saveContactPreferencesError);
  var contactPreferences = (0, _map2["default"])((0, _get4["default"])(contactPrefsResponse, 'preferences', []), function (pref) {
    return (0, _fixContactPrefLinks.fixContactPrefLinks)(pref, appName);
  });
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    className: "account-modal email-preferences",
    id: "contact-preferences-modal",
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Email & Phone Preferences"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "contact-preferences",
    onSubmit: handleSubmit(function (values) {
      submit(userId, values, handleClose, saveUserContactPreferences, saveAssociateContactPreferences, appName);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "account-modal email-pref-modal-content"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_contactPreferenceCopy["default"], {
    email: email
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], null, (0, _map2["default"])(contactPreferences, function (_ref2) {
    var key = _ref2.key,
      displayName = _ref2.displayName,
      description = _ref2.description,
      rank = _ref2.rank;
    return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], {
      key: rank
    }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
      name: key,
      type: "checkbox",
      id: "contact-preferences-modal--checkbox-id".concat(rank),
      label: /*#__PURE__*/_react["default"].createElement("b", null, displayName)
    }), description);
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    disabled: pristine || invalid || isContactPreferenceLoading,
    loading: isContactPreferenceLoading || isSaveContactPreferencesLoading,
    bsSize: "small",
    type: "submit"
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences-modal--cancel-button",
    flat: true,
    bsSize: "small",
    bsStyle: cancelButtonStyle,
    onClick: function onClick() {
      return handleClose();
    }
  }, "Cancel")))));
};
ContactPreferencesModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  cancelButtonStyle: _propTypes["default"].string.isRequired,
  userId: _propTypes["default"].string,
  email: _propTypes["default"].string,
  gateWay: _propTypes["default"].object,
  saveUserContactPreferences: _propTypes["default"].func.isRequired,
  saveAssociateContactPreferences: _propTypes["default"].func.isRequired,
  appName: _propTypes["default"].string.isRequired,
  // redux form
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  reset: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var ContactPreferencesModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'contact-preferences',
  enableReinitialize: true
})(ContactPreferencesModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  var gateWay = state.config.appName === 'office-app' ? state.serviceProviderGateway : state.memberManagementGateway;
  var getContactPreferences = (0, _get4["default"])(gateWay, 'getContactPreferences.response.preferences', {});
  var keyValuesArray = (0, _map2["default"])(getContactPreferences, function (pref) {
    return [pref.key, pref.enabled];
  });
  var fieldValues = (0, _fromPairs2["default"])(keyValuesArray);
  return {
    gateWay: gateWay,
    serviceProviderGateway: state.serviceProviderGateway,
    appName: state.config.appName,
    initialValues: fieldValues
  };
}, _objectSpread(_objectSpread(_objectSpread({}, memberMgmtGatewayActions), serviceProviderGatewayActions), myAccountUIActions)), _pure["default"])(ContactPreferencesModalReduxForm);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/modals/contactPreferencesModal.js
// module id = 4292
// module chunks = 9